import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Plus, FileText, Send, Printer } from 'lucide-react';
interface QuoteBuilderProps {
  onLogout: () => void;
}
export function QuoteBuilder({
  onLogout
}: QuoteBuilderProps) {
  return <MainLayout title="Angebotserstellung" onLogout={onLogout} data-id="element-1039">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1040">
        {/* Left: Package Selection */}
        <div className="lg:col-span-2 space-y-6" data-id="element-1041">
          <Card title="Hardware & Services Packages" data-id="element-1042">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1043">
              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-1044">
                <div className="flex justify-between items-start mb-2" data-id="element-1045">
                  <h3 className="font-semibold text-slate-900" data-id="element-1046">
                    Standard Arbeitsplatz
                  </h3>
                  <Badge variant="secondary" data-id="element-1047">Hardware</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-1048">
                  Dell Latitude 5520, Docking Station, 2x 24" Monitor,
                  Maus/Tastatur
                </p>
                <div className="flex justify-between items-center" data-id="element-1049">
                  <span className="font-bold text-slate-900" data-id="element-1050">€ 1.499,00</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-1052" />} data-id="element-1051">
                    Hinzufügen
                  </Button>
                </div>
              </div>

              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-1053">
                <div className="flex justify-between items-start mb-2" data-id="element-1054">
                  <h3 className="font-semibold text-slate-900" data-id="element-1055">
                    Managed Antivirus
                  </h3>
                  <Badge variant="info" data-id="element-1056">Service</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-1057">
                  SentinelOne Endpoint Protection, 24/7 Monitoring, Monatlich
                  pro Client
                </p>
                <div className="flex justify-between items-center" data-id="element-1058">
                  <span className="font-bold text-slate-900" data-id="element-1059">€ 4,50 / M</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-1061" />} data-id="element-1060">
                    Hinzufügen
                  </Button>
                </div>
              </div>

              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-1062">
                <div className="flex justify-between items-start mb-2" data-id="element-1063">
                  <h3 className="font-semibold text-slate-900" data-id="element-1064">
                    M365 Business Standard
                  </h3>
                  <Badge variant="info" data-id="element-1065">Lizenz</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-1066">
                  Office Apps, Exchange, Teams, SharePoint. Monatlich pro User.
                </p>
                <div className="flex justify-between items-center" data-id="element-1067">
                  <span className="font-bold text-slate-900" data-id="element-1068">€ 12,80 / M</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-1070" />} data-id="element-1069">
                    Hinzufügen
                  </Button>
                </div>
              </div>

              <div className="border border-slate-200 rounded-lg p-4 hover:border-teal-500 cursor-pointer transition-colors" data-id="element-1071">
                <div className="flex justify-between items-start mb-2" data-id="element-1072">
                  <h3 className="font-semibold text-slate-900" data-id="element-1073">
                    Einrichtungspauschale
                  </h3>
                  <Badge variant="warning" data-id="element-1074">Dienstleistung</Badge>
                </div>
                <p className="text-sm text-slate-500 mb-4" data-id="element-1075">
                  Installation, Konfiguration, Einbindung ins Netzwerk (ca. 2
                  Std)
                </p>
                <div className="flex justify-between items-center" data-id="element-1076">
                  <span className="font-bold text-slate-900" data-id="element-1077">€ 190,00</span>
                  <Button size="sm" variant="outline" leftIcon={<Plus className="h-3 w-3" data-id="element-1079" />} data-id="element-1078">
                    Hinzufügen
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Right: Quote Preview */}
        <div className="lg:col-span-1" data-id="element-1080">
          <Card title="Aktuelles Angebot" className="h-full flex flex-col" data-id="element-1081">
            <div className="flex-1" data-id="element-1082">
              <div className="mb-4 pb-4 border-b border-slate-100" data-id="element-1083">
                <h4 className="text-sm font-medium text-slate-500" data-id="element-1084">Kunde</h4>
                <p className="font-semibold text-slate-900" data-id="element-1085">Müller GmbH</p>
              </div>

              <div className="space-y-3 mb-6" data-id="element-1086">
                <div className="flex justify-between text-sm" data-id="element-1087">
                  <span data-id="element-1088">1x Standard Arbeitsplatz</span>
                  <span className="font-medium" data-id="element-1089">1.499,00 €</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-1090">
                  <span data-id="element-1091">1x Einrichtungspauschale</span>
                  <span className="font-medium" data-id="element-1092">190,00 €</span>
                </div>
                <div className="flex justify-between text-sm text-slate-500 pt-2 border-t border-slate-100" data-id="element-1093">
                  <span data-id="element-1094">Zwischensumme</span>
                  <span data-id="element-1095">1.689,00 €</span>
                </div>
                <div className="flex justify-between text-sm text-slate-500" data-id="element-1096">
                  <span data-id="element-1097">MwSt. (19%)</span>
                  <span data-id="element-1098">320,91 €</span>
                </div>
                <div className="flex justify-between text-lg font-bold text-slate-900 pt-2 border-t border-slate-200" data-id="element-1099">
                  <span data-id="element-1100">Gesamt</span>
                  <span data-id="element-1101">2.009,91 €</span>
                </div>
              </div>
            </div>

            <div className="space-y-2 mt-auto" data-id="element-1102">
              <Button className="w-full" leftIcon={<Send className="h-4 w-4" data-id="element-1104" />} data-id="element-1103">
                Angebot versenden
              </Button>
              <Button variant="secondary" className="w-full" leftIcon={<Printer className="h-4 w-4" data-id="element-1106" />} data-id="element-1105">
                PDF Vorschau
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </MainLayout>;
}